import styled, { css } from 'styled-components';
import { redColor, lightGrey1Color } from 'js/config/style';

const errorStyle = css`
  color: white;
  background: ${redColor};
  border-color: ${redColor};
`;

export default styled.div`
  padding: 1rem;
  margin-top: 1rem;
  grid-column: 1 / 3;
  font-weight: 500;
  background: ${lightGrey1Color};
  border: 1px solid ${lightGrey1Color.darken()};
  border-radius: 0.25rem;
  ${({ error }) => error && errorStyle}
  display: grid;
  grid-row-gap: 0.5rem;
`;
